<main class="main">
  <mat-dialog-content>
    <h2 class="main--text">{{ 'addDocumentation' | i18next }}</h2>
  </mat-dialog-content>
  <form [formGroup]="form" class="main--form">
    <mat-form-field>
      <mat-label>{{ 'chooseDocu' | i18next }}</mat-label>
      <mat-select formControlName="documentType" [disabled]="!!data.docType">
        <mat-option *ngFor="let document of documentation" [value]="document">
          {{ document | i18next }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <div class="drag-drop">
      <file-pond
        #myPond
        [options]="pondOptions"
        [files]="pondFiles"
        (onaddfile)="pondHandleAddFile($event)"
      >
      </file-pond>
      <p *ngIf="genericErr" class="error">
        {{ errorMsg }}
      </p>
    </div>
  </form>

  <mat-dialog-actions>
    <button
      type="button"
      class="btn btn-cancel"
      [disabled]="isSendingFile"
      mat-dialog-close>
      {{ 'altCancel' | i18next }}
    </button>
    <button
      type="button"
      class="btn"
      [disabled]="!documento || form.invalid || genericErr || emptyErr || isSendingFile"
      (click)="uploadFiles()"
    >
      {{ 'btnSend' | i18next }}
    </button>
  </mat-dialog-actions>
</main>
